import React from 'react'
import { useState, useEffect, useRef } from 'react'
import { View, TextInput, TouchableOpacity, StyleSheet } from 'react-native'
import theme from '../../../theme'
import StyledText from '../../../StyledText'
import parseThousands from '../customUtils/parseThousands/parseThousands'
import { apiUrl } from '../../config/config'
import { Ionicons } from '@expo/vector-icons'
import { Feather } from '@expo/vector-icons'
import styles from './CommentsPostsStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'

const CommentsPosts = ({ posts, onCommentClick, allComments, handleSendCommentLikes, firstComment, commentCount }) => {
    const MAX_COMMENT_LENGTH = 10 // Número máximo de palabras a mostrar
    const [expanded, setExpanded] = useState(false)

    // Función para recortar el comentario si es muy largo
    const truncateComment = (comment) => {
        if (comment.length <= MAX_COMMENT_LENGTH) {
            return comment
        }
        const words = comment.split(' ')
        const truncated = words.slice(0, MAX_COMMENT_LENGTH).join(' ')
        return truncated + '...'
    }

    const handleCommentClick = () => {
        setExpanded(!expanded)
    }

    const { languageFile } = getLanguage()

    return (
        <View>
            {firstComment && firstComment?._id && (
                <View style={styles.commentsPostContainer}>
                    <View style={styles.commentsPost}>
                        <TouchableOpacity onPress={onCommentClick}>
                            <StyledText fontWeight='bold' fontSize='mediumText'>
                                {firstComment?.name} <StyledText fontWeight='normal' fontSize='mediumText' numberOfLines={expanded ? undefined : 2}>
                                    {expanded ? firstComment?.comment : truncateComment(firstComment?.comment)}
                                </StyledText>
                            </StyledText>
                            {/* {allComments[0]?.comment.length > MAX_COMMENT_LENGTH && (
                                <TouchableOpacity onPress={handleCommentClick}>
                                    <StyledText fontWeight='light' fontSize='smallText' color={'textSecondary'}>
                                        {expanded ? 'Ver menos' : 'Ver más'}
                                    </StyledText>
                                </TouchableOpacity>
                            )} */}
                        </TouchableOpacity>
                    </View>

                    <TouchableOpacity onPress={() => handleSendCommentLikes(firstComment?._id)} style={styles.commentsLikeCuore}>
                        <Ionicons
                            name={(firstComment ? firstComment?.isSelected : false) ? 'heart-sharp' : 'heart-outline'}
                            size={18}
                            color={(firstComment ? firstComment?.isSelected : false) ? theme.colors.colorTertiary : theme.colors.colorTertiary}
                            style={styles.commentsLike}
                        />
                    </TouchableOpacity>
                </View>
            )}
            {commentCount && commentCount !== '0' && (
                <TouchableOpacity style={styles.commentsCTA} onPress={onCommentClick}>
                    <StyledText fontWeight='light' fontSize='smallText' color={'textSecondary'}>
                        {languageFile.see_them}
                        {commentCount}
                        {languageFile._comments}
                    </StyledText>
                </TouchableOpacity>
            )}
        </View>
    )
    // return (
    //     <View>
    //         {allComments && allComments.length > 0 && (
    //             <View style={styles.commentsPostContainer}>
    //                 <View style={{ width: '96%' }}>
    //                     <StyledText fontWeight='bold' fontSize='normalText'>
    //                         {allComments[0]?.name}
    //                         {''}
    //                         <StyledText> </StyledText>
    //                         <StyledText fontWeight='normal' fontSize='mediumText' numberOfLines={2}>
    //                             {allComments[0]?.comment}
    //                         </StyledText>
    //                     </StyledText>
    //                     {/*
    //                         <TouchableOpacity>
    //                             <StyledText fontWeight='light' fontSize='smallText' color={'textSecondary'}>
    //                                 Responder
    //                             </StyledText>
    //                         </TouchableOpacity>
    //                     */}
    //                 </View>

    //                 <TouchableOpacity onPress={() => handleSendCommentLikes(allComments[0]?._id)} style={styles.commentsLikeCuore}>
    //                     <Ionicons
    //                         name={(allComments[0] ? allComments[0]?.isSelected : false) ? 'heart-sharp' : 'heart-outline'}
    //                         size={18}
    //                         color={(allComments[0] ? allComments[0]?.isSelected : false) ? theme.colors.colorTertiary : theme.colors.colorTertiary}
    //                         style={styles.commentsLike}
    //                     />

    //                     {/*
    //                         <View style={styles.commentsLikeCuore}>
    //                             <StyledText fontWeight='normal' fontSize='ultraSmallText' style={styles.likesCount}>
    //                                 {parseThousands(allComments[0]?.likes_count)}
    //                             </StyledText>
    //                         </View>
    //                     */}
    //                 </TouchableOpacity>
    //             </View>
    //         )}
    //         {allComments.length > 0 && (
    //             <TouchableOpacity style={styles.commentsCTA} onPress={onCommentClick}>
    //                 <StyledText fontWeight='light' fontSize='smallText' color={'textSecondary'}>
    //                     Ver los {allComments.length} comentarios
    //                 </StyledText>
    //             </TouchableOpacity>
    //         )}
    //     </View>
    // )
}

export default CommentsPosts
